import { FC } from 'react';

import { SubcontractorStatusEnum } from '../../enum';
import { CoreStatus } from '../CoreStatus';

interface SubcontractorStatusProps {
  value: SubcontractorStatusEnum;
  displayName?: string;
}

const SubcontractorStatusColor = {
  [SubcontractorStatusEnum.Done]: '#22C55E',
  [SubcontractorStatusEnum.InProgress]: '#06B6D4',
  [SubcontractorStatusEnum.Pending]: '#737373',
  [SubcontractorStatusEnum.Released]: '#D19500',
  [SubcontractorStatusEnum.NA]: '#737373',
};
export const SubcontractorStatus: FC<SubcontractorStatusProps> = ({
  value,
  displayName,
}) => (
  <CoreStatus
    value={displayName || value}
    backgroundColor={SubcontractorStatusColor[value]}
  />
);
